import { useState } from 'react';
import { Modal, Button, Form, Alert } from 'react-bootstrap';
import { useAuth } from '../../api/AuthProvider';

export default function LoginModal({ show, onHide, onSuccess }) {
    const { login } = useAuth();
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [busy, setBusy] = useState(false);
    const [err, setErr] = useState('');

    async function handleSubmit(e) {
        e.preventDefault();
        setBusy(true); setErr('');
        try {
            await login(email, password);
            onSuccess?.();   // parent can navigate to /account
            onHide?.();
        } catch {
            setErr('Invalid email or password.');
        } finally {
            setBusy(false);
        }
    }

    return (
        <Modal show={show} onHide={onHide} centered>
            <Form onSubmit={handleSubmit}>
                <Modal.Header closeButton>
                    <Modal.Title>Log in</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {err && <Alert variant="danger" className="py-2">{err}</Alert>}
                    <Form.Group className="mb-3">
                        <Form.Label>Email</Form.Label>
                        <Form.Control type="email" required value={email} onChange={e=>setEmail(e.target.value)} autoFocus />
                    </Form.Group>
                    <Form.Group>
                        <Form.Label>Password</Form.Label>
                        <Form.Control type="password" required value={password} onChange={e=>setPassword(e.target.value)} />
                    </Form.Group>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={onHide} disabled={busy}>Cancel</Button>
                    <Button variant="primary" type="submit" disabled={busy}>{busy ? 'Logging in…' : 'Log in'}</Button>
                </Modal.Footer>
            </Form>
        </Modal>
    );
}
